import {Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {IackathonLearnerSelfReviewsComponent} from '../iackathon-learner-self-reviews.component';

@Component({
    selector: 'app-iackathon-learner-self-reviews-modal',
    imports: [
        IackathonLearnerSelfReviewsComponent
    ],
    templateUrl: './iackathon-learner-self-reviews-modal.component.html',
    styleUrl: './iackathon-learner-self-reviews-modal.component.scss',
})
export class IackathonLearnerSelfReviewsModalComponent {
    public data = inject(MAT_DIALOG_DATA)
}
